var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editor',{attrs:{"id":_vm.id? _vm.id : 'tiny-html-editor',"api-key":_vm.tinyConfig.api_key,"init":_vm.configWithLanguage,"initial-value":_vm.initialValue,"disabled":_vm.disabled},on:{"change":_vm.handleChange,"input":_vm.handleInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }